export default __webpack_public_path__ + "static/media/username.deba9d33.svg";